import { render, staticRenderFns } from "./newAcgDetail.vue?vue&type=template&id=409284ee&scoped=true&"
import script from "./newAcgDetail.vue?vue&type=script&lang=js&"
export * from "./newAcgDetail.vue?vue&type=script&lang=js&"
import style0 from "./newAcgDetail.vue?vue&type=style&index=0&id=409284ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409284ee",
  null
  
)

export default component.exports